export default __webpack_public_path__ + "static/media/Pot3.81d81eb3.svg";